import CustomCheckBox from "../atomic/CustomCheckBox";
import Button from "./Button";
import { optionType } from "./CustomSelect";
interface SuggestionProps {
  text: string;
  onOptionClick: (args: any) => void;
  suggestions: optionType[];
  isVisible: boolean;
  setIsVisible: (state: boolean) => void;
  hasError: boolean;
  multiSelect?: {
    fieldName: string;
  };
  values?: any;
}

function Suggestions({
  text,
  onOptionClick,
  suggestions,
  isVisible,
  hasError,
  setIsVisible,
  multiSelect,
  values,
}: SuggestionProps) {
  function handleSearchAndSort() {
    return suggestions
      .filter((option) => option.label.toLowerCase().indexOf(text) > -1)
      .concat(
        suggestions.filter(
          (option) => option.label.toLowerCase()?.indexOf(text) === -1
        )
      );
  }

  if (isVisible && suggestions.length > 0)
    return (
      <div
        className={`absolute bg-white w-full border rounded-md ${hasError ? "-mt-8" : "-mt-4"
          } shadow-md max-h-[200px] overflow-auto z-[9999999999]`} // Adjusted z-index
      // Absolute positioning via className
      >
        <ul>
          {handleSearchAndSort().map((item, index) => {
            if (multiSelect?.fieldName) {
              const itemValue =
                typeof item.value === "number"
                  ? item.value.toString()
                  : item.value;
              const checked =
                values?.[multiSelect.fieldName]?.includes?.(itemValue);

              return (
                <div
                  key={item.label + index}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    // Handle Enter and Space key presses
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.stopPropagation();
                      // Trigger the checkbox click
                      const checkbox = e.currentTarget.querySelector('input[type="checkbox"]') as HTMLInputElement;
                      if (checkbox) {
                        checkbox.click();
                      }
                    }
                  }}
                >
                  <CustomCheckBox
                    key={item.label + index}
                    name={multiSelect.fieldName}
                    label={item.label}
                    value={item.value}
                    id={item.label}
                    checked={checked}
                    customCheckBox
                    onClick={() => setIsVisible(false)}
                    checkBoxClassName="flex items-center p-2 px-4 hover:bg-sideMenuHoverBg"
                  />
                </div>
              );
            }

            return (
              <Button
                key={index + item.label}
                buttonTheme="transparent"
                type="button"
                textInformation={{
                  text: item.label,
                  fontWeight: "font-normal",
                  fontSize: "text-base",
                }}
                className="hover:bg-sideNavGray hover:text-royalBlue p-2 w-full text-left overflow-none !normal-case"
                onMouseDown={(e) => {
                  e.preventDefault(); // Prevent input blur
                  e.stopPropagation();
                  onOptionClick(item);
                  setIsVisible(false);
                }}
                onKeyDown={(e) => {
                  // Handle Enter and Space key presses
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.stopPropagation();
                    onOptionClick(item);
                    setIsVisible(false);
                  }
                }}
                onClick={() => { }}
              />
            );
          })}
        </ul>
      </div>
    );
  return null;
}

export default Suggestions;
